export default "__VITE_ASSET__DYPB1o0k__"